<template>
  <div class="page">
    <div v-if="loading == true" class="page-loader">
      <LoadingRoller />
    </div>
    <div v-if="loading == false">
      <section class="page-toolbar" aria-label="أدوات العرض">
        <div class="page-toolbar__row">
          <b-form-datepicker
            v-if="showClientHistory == false"
            id="example-datepicker"
            v-model="date"
            @input="onDateChange"
          ></b-form-datepicker>
          <b-button
            v-if="showClientHistory"
            variant="outline-primary"
            class="app-btn"
            @click="loadVisits()"
          >
            <v-icon small>mdi-arrow-right</v-icon>
            الرجوع للزيارات
          </b-button>
          <b-button v-if="showClientHistory == false" variant="primary" class="app-btn" @click="goToSalesmen()">الصيانة</b-button>
        </div>
        <DayChips v-if="showClientHistory == false" :chip="chip" :selection.sync="selection" @select="selectDay" />
      </section>

      <div v-if="ExistVisits == true && loading == false" class="empty-state">
        <v-icon size="48" color="primary">mdi-calendar-blank-outline</v-icon>
        <p class="empty-state__text">لا يوجد زيارات عند التاريخ المحدد</p>
      </div>

      <!-- Confirmation modals, opened from the card buttons through $bvModal.show(id). -->
      <b-modal id="bv-modal-startSession" hide-footer centered>
        <template #modal-title>تأكيد بداية الجلسة</template>
        <p class="confirm-dialog__text">هل أنت متأكد ابتداء الجلسة</p>
        <b-button variant="primary" class="app-btn" block @click="$bvModal.hide('bv-modal-startSession'); editStartSession(id);">تأكيد</b-button>
      </b-modal>
      <b-modal id="bv-modal-endSession" hide-footer centered>
        <template #modal-title>تأكيد انتهاء الجلسة</template>
        <p class="confirm-dialog__text">هل أنت متأكد من انتهاء الجلسة</p>
        <b-button variant="primary" class="app-btn" block @click="$bvModal.hide('bv-modal-endSession'); editFinishSession(id);">تأكيد</b-button>
      </b-modal>
      <b-modal id="bv-modal-CancelSession" hide-footer centered>
        <template #modal-title>تأكيد إلغاء الجلسة</template>
        <p class="confirm-dialog__text">هل أنت متأكد من إلغاء الجلسة</p>
        <b-button variant="danger" class="app-btn" block @click="$bvModal.hide('bv-modal-CancelSession'); editCancelSession(id);">تأكيد</b-button>
      </b-modal>

      <div class="card-grid">
        <div class="card-grid__item" v-for="(item, i) in products" :key="i">
          <!--
            One card template for every visit. "Active" visits (today, still pending, not cancelled)
            get the animated border and the blinking time; finished ones a soft green background.
          -->
          <v-card
            v-if="item.ClientName != undefined && loading == false"
            :class="['visit-card', { 'visit-card--active': isActiveVisit(item), 'visit-card--finished': item.finishSession != null }]"
          >
            <div v-if="isActiveVisit(item)" class="visit-card__glow" aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <VisitCardTitle
              :client-name="item.ClientName"
              :branch-name="item.BranchName"
              :address="item.Address"
            />

            <div class="visit-card__meta">
              <span :class="['visit-card__time', { 'is-blinking': isActiveVisit(item) }]">
                <svg-icon type="mdi" :path="pathClock"></svg-icon>
                {{ showClientHistory ? item.timedate : item.appointment }}
              </span>
              <span v-if="item.IsCancelSession == 1" class="status-badge status-badge--danger"><svg-icon type="mdi" :path="pathCancel"></svg-icon>ملغاة</span>
              <span v-else-if="item.startSession != null && item.IsLate2 == 0" class="status-badge status-badge--success"><svg-icon type="mdi" :path="pathCheckCircle"></svg-icon>تمت عالموعد</span>
              <span v-else-if="item.IsLate2 == 1 && item.finishSession != null" class="status-badge status-badge--warning"><svg-icon type="mdi" :path="pathCheckCircle"></svg-icon>تمت متأخرة</span>
              <span v-if="item.IsAnydesk" class="status-badge status-badge--info">عن بعد</span>
            </div>
            <v-divider></v-divider>

            <div class="visit-card__body">
              <p v-if="admin == true" class="visit-card__line_black">
                <span class="visit-card__label">الموظف</span>
                {{ item.DisplayName }}
              </p>

              <p v-if="item.Converter != null && item.Converter != ''" class="visit-card__line_black">
                <span class="visit-card__strong">{{ item.task + ' / ' + item.Converter }}</span><br>{{ item.ChannelName }}
              </p>
              <p v-else class="visit-card__line_black">
                <span class="visit-card__strong">{{ item.task }}</span><br>{{ item.ChannelName }}
              </p>

              <PhoneLinks v-if="item.PhoneNumber != null" :phone="item.PhoneNumber" />
              <Attachment v-if="showClientHistory == false" :id="item.id" :name="item.NameFile" :imageSrc="item.Attachment" :chip="chip" :date="date"></Attachment>
              <div v-if="showClientHistory == false">
                <b-button variant="outline-primary" class="app-btn app-btn--sm" @click="displayVisitsClient(item.ClientId, item.BranchId)">
                  <v-icon small>mdi-history</v-icon>
                  عرض زيارات العميل
                </b-button>
              </div>

              <template v-if="item.IsPaid">
                <label class="field">
                  <span class="field__label">مأجورة</span>
                  <span class="field__control">
                    <input type="number" class="field__input" :placeholder="item.visitFees" v-model="item.visitFees" />
                    <span class="field__suffix">د.ع</span>
                  </span>
                </label>
                <div>
                  <label class="choice">
                    <input type="checkbox" :id="`one${item.id}`" :value="true" v-model="item.IsDonePaid" />
                    تم التحصيل
                  </label>
                </div>
              </template>

              <div v-if="item.startSession != null || item.finishSession != null" class="visit-card__sessions">
                <span v-if="item.startSession != null" class="visit-card__session" title="بداية الجلسة">
                  <svg-icon color="green" type="mdi" :path="pathClockIn"></svg-icon> {{ item.startSession }}
                </span>
                <span v-if="item.finishSession != null" class="visit-card__session" title="نهاية الجلسة">
                  <svg-icon color="green" type="mdi" :path="pathClockEnd"></svg-icon> {{ item.finishSession }}
                </span>
              </div>
            </div>

            <v-card-actions
              v-if="(new Date(date) > new Date() || chip == 0) && (isActiveVisit(item) || item.IsCancelSession == 0) && showClientHistory == false"
              class="visit-card__actions"
            >
              <b-button class="app-btn icon-btn" v-if="item.cost >= 250 && item.IsPaid" @click="pay(item.cost)" variant="light" aria-label="دفع" title="دفع"><svg-icon color="green" type="mdi" :path="pathCash"></svg-icon></b-button>
              <b-button class="app-btn icon-btn" v-if="item.startSession == null" id="show-btn" @click="selectVisit(item.id, item.appointment, item.IsLate, item.startSession); $bvModal.show('bv-modal-startSession');" variant="light" aria-label="بدء الجلسة" title="بدء الجلسة"><svg-icon color="red" type="mdi" :path="pathClockIn"></svg-icon></b-button>
              <!-- isDetailsToggled is shared by every card (original behaviour): it flips all chevrons. -->
              <b-button variant="light" class="app-btn icon-btn" :aria-expanded="String(!!showDetails[i])" aria-label="التفاصيل" title="التفاصيل" @click="isDetailsToggled = !isDetailsToggled; showDetails[i] = !showDetails[i]">
                <svg-icon v-if="isDetailsToggled" type="mdi" :path="pathUp"></svg-icon><svg-icon v-else type="mdi" :path="pathDown"></svg-icon>
              </b-button>
              <b-button variant="light" class="app-btn icon-btn" v-if="item.finishSession == null && (savedDetails[i] != null && savedDetails[i] != '') && item.startSession != null" aria-label="إنهاء الجلسة" title="إنهاء الجلسة" @click="$bvModal.show('bv-modal-endSession'); selectVisit(item.id, item.appointment, item.IsLate, item.startSession);"><svg-icon color="red" type="mdi" :path="pathClockEnd"></svg-icon></b-button>
            </v-card-actions>
            <p v-else class="visit-card__details">{{ item.details }}</p>

            <v-expand-transition v-if="new Date(date) > new Date() || chip == 0">
              <div v-if="showDetails[i]" class="visit-card__section">
                <v-textarea outlined hide-details="auto" label="التفاصيل" name="details" v-model="item.details"
                  :rules="[$rules.required()]"></v-textarea>
                <div class="visit-card__form-actions">
                  <v-btn v-if="item.details != ''" depressed color="primary" @click="editDetails(item.id, item.details, i, item.IsDonePaid, item.visitFees)">تم</v-btn>
                  <v-btn v-if="item.IsCancelSession == false && item.details != ''" depressed outlined color="error" @click="selectVisitForCancel(item.id, item.details, item.CountHourSession, item.indexAppointment, item.UserId, item.TIMESTAMP, i); $bvModal.show('bv-modal-CancelSession');">إلغاء الزيارة</v-btn>
                </div>
              </div>
            </v-expand-transition>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@jamescoyle/vue-icon";
import {
  mdiCancel,
  mdiCash,
  mdiCheckCircleOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiClockCheckOutline,
  mdiClockEnd,
  mdiClockIn,
} from "@mdi/js";
import DayChips from "@/components/DayChips.vue";
import LoadingRoller from "@/components/LoadingRoller.vue";
import PhoneLinks from "@/components/PhoneLinks.vue";
import { encryptText } from "@/utils/crypto";
import {
  currentTimeBaghdad,
  daysFromToday,
  formatDateISO,
  getDateChip,
} from "@/utils/date";
import { toInternationalPhone } from "@/utils/phone";
import Attachment from "./attachment.vue";
import VisitCardTitle from "./VisitCardTitle.vue";

// A pending visit (IsLate == 1) scheduled for the current hour is not late yet.
const relaxLateFlag = (visit, currentHour) => {
  if (currentHour === new Date(visit.timedate.toString()).getUTCHours() && visit.IsLate == 1) {
    visit.IsLate = 0;
  }
};

/**
 * The device's location, or null if it is refused, unavailable or takes too long. Some browsers never call back
 * (an ignored permission prompt), so a timer settles it too: before, starting a session then waited forever.
 */
const getCoordsOrNull = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }
    const guard = setTimeout(() => resolve(null), 20000);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        clearTimeout(guard);
        resolve(coords);
      },
      () => {
        clearTimeout(guard);
        resolve(null);
      },
      { enableHighAccuracy: false, maximumAge: 60000, timeout: 15000 }
    );
  });

const normalizePhone = (visit) => {
  if (visit.PhoneNumber != null) {
    visit.PhoneNumber = toInternationalPhone(visit.PhoneNumber);
  }
};

export default {
  name: "Visits",
  components: {
    SvgIcon,
    Attachment,
    DayChips,
    LoadingRoller,
    PhoneLinks,
    VisitCardTitle,
  },
  data() {
    return {
      loading: false,
      // Tasks running under withLoading; the spinner goes off when the last one ends.
      pending: 0,
      // Number of the latest list load; an answer to an older one is ignored.
      lastRequest: 0,
      admin: false,
      ExistVisits: false,
      // The initial placeholder row is intentional: it keeps the first render identical to the original.
      products: [{}],
      chip: 0,
      // Selected index of the day chips (owned here: see DayChips).
      selection: 1,
      date: new Date(),
      // true while the list shows the full history of one client ("عرض زيارات العميل").
      showClientHistory: false,
      isDetailsToggled: false,
      showDetails: [],
      savedDetails: [],
      // Visit picked by a card button; read by the confirmation modals.
      id: "",
      appointment: "",
      IsLate: 0,
      startSession: "",
      cancelTarget: {
        details: "",
        CountHourSession: 1,
        indexAppointment: 0,
        UserId: 1,
        TIMESTAMP: "",
        index: 0,
      },
      pathUp: mdiChevronUp,
      pathDown: mdiChevronDown,
      pathClockIn: mdiClockIn,
      pathClockEnd: mdiClockEnd,
      pathClock: mdiClockCheckOutline,
      pathCheckCircle: mdiCheckCircleOutline,
      pathCash: mdiCash,
      pathCancel: mdiCancel,
    };
  },
  created() {
    this.loadVisits();
    // NOTE: never removed on destroy (same as the original): other screens emit "refresh-data" too.
    this.$root.$on("refresh-data", () => {
      this.loadVisits();
    });
  },
  methods: {
    /** Today's pending visit that is not cancelled: rendered with the animated border. */
    isActiveVisit(item) {
      return this.chip == 0 && item.IsLate == -1 && item.IsCancelSession != 1;
    },
    goToSalesmen() {
      this.$router.push({ name: "salesmen" });
      localStorage.setItem("page", "salesmen");
    },
    /**
     * Runs `task` with the spinner on. The spinner always goes off, also when a request fails or times out
     * (the http interceptor has already reported that); before, a failed request left the screen frozen on it.
     */
    async withLoading(task) {
      this.pending++;
      this.loading = true;
      try {
        await task();
      } catch (error) {
        if (!error.isAxiosError) {
          console.error(error);
          this.$store.commit("UPDATE_SNACKBAR_MESSAGE", { message: `حدث خطأ: ${error.message}` });
          this.$store.commit("UPDATE_SNACKBAR", true);
        }
      } finally {
        if (--this.pending == 0) {
          this.loading = false;
          this.$store.commit("setLoading", false);
        }
      }
    },
    pay(cost) {
      return this.withLoading(async () => {
        const res = await this.$http.get("/pay", { params: { cost } });
        window.location.href = res.data;
      });
    },
    selectVisit(id, appointment, IsLate, startSession) {
      this.id = id;
      this.appointment = appointment;
      this.IsLate = IsLate;
      this.startSession = startSession;
    },
    selectVisitForCancel(id, details, CountHourSession, indexAppointment, UserId, TIMESTAMP, index) {
      this.id = id;
      this.cancelTarget = { details, CountHourSession, indexAppointment, UserId, TIMESTAMP, index };
    },
    editDetails(id, details, index, IsDonePaid, visitFees) {
      return this.withLoading(async () => {
        const res = await this.$http.post("/reportEditDetails", {
          id: encryptText(id.toString()),
          details,
          IsDonePaid,
          visitFees,
        });
        // Plain index assignment on purpose: the end-session button reads it on the next render.
        if (res.status == 200) this.savedDetails[index] = details;
        this.isDetailsToggled = false;
        this.$root.$emit("refresh-data");
      });
    },
    editCancelSession(id) {
      const { details, CountHourSession, indexAppointment, UserId, TIMESTAMP, index } = this.cancelTarget;
      return this.withLoading(async () => {
        const res = await this.$http.post("/reportEditCancelSession", {
          id: encryptText(id.toString()),
          IsCancelSession: 1,
          details,
          CountHourSession,
          indexAppointment,
          UserId,
          TIMESTAMP,
        });
        if (res.status == 200) this.savedDetails[index] = details;
        this.isDetailsToggled = false;
        this.$root.$emit("refresh-data");
      });
    },
    editStartSession(id) {
      return this.withLoading(async () => {
        // Opens the browser's location permission popup; without a position the visit starts without coordinates.
        const coords = await getCoordsOrNull();
        await this.$http.post("/reportEditStartTime", {
          id: encryptText(id.toString()),
          startSession: currentTimeBaghdad(),
          appointment: this.appointment,
          latitude: coords ? coords.latitude : null,
          longitude: coords ? coords.longitude : null,
        });
        this.$root.$emit("refresh-data");
      });
    },
    editFinishSession(id) {
      return this.withLoading(async () => {
        await this.$http.post("/reportEditFinishTime", {
          id: encryptText(id.toString()),
          finishSession: currentTimeBaghdad(),
          IsLate: this.IsLate,
          startSession: this.startSession,
          appointment: this.appointment,
        });
        this.$root.$emit("refresh-data");
      });
    },
    selectDay(offset) {
      this.chip = offset;
      this.date = formatDateISO(daysFromToday(offset));
      this.onDateChange();
    },
    /** Date picker / chip changed: loads the visits of `this.date`. */
    onDateChange() {
      this.chip = getDateChip(this.date);
      this.showDetails = [];
      this.savedDetails = [];
      return this.withLoading(() => this.fetchVisits(this.date));
    },
    /** Loads the visits of the date held in `this.date` (or jumps to the salesmen screen if that was the last one used). */
    loadVisits() {
      this.showClientHistory = false;
      if (localStorage.getItem("page") == "salesmen") {
        this.$router.push({ name: "salesmen" });
        return;
      }
      this.showDetails = [];
      return this.withLoading(() => this.fetchVisits(formatDateISO(new Date(this.date))));
    },
    async fetchVisits(date) {
      const request = ++this.lastRequest;
      this.$store.commit("setLoading", true);
      const res = await this.$http.get("/visits", {
        params: {
          date: encryptText(date),
          id: encryptText(localStorage.getItem("userData")),
          tocken: encryptText(Date.now().toString()),
        },
      });
      // A slow answer for a date picked earlier must not replace the visits of the date picked since.
      if (res.status != 200 || request != this.lastRequest) return;
      this.products = res.data.result;
      this.admin = res.data.admin;
      this.ExistVisits = this.products.length == 0;
      const currentHour = new Date().getHours();
      this.showDetails = [];
      this.savedDetails = [];
      this.products.forEach((visit) => {
        relaxLateFlag(visit, currentHour);
        normalizePhone(visit);
        this.showDetails.push(false);
        this.savedDetails.push(visit.details);
      });
    },
    /** Replaces the list with the whole visit history of one client / branch. */
    displayVisitsClient(clientId, branchId) {
      return this.withLoading(async () => {
        const request = ++this.lastRequest;
        this.$store.commit("setLoading", true);
        const res = await this.$http.get("/disblayVisits", { params: { clientId, branchId } });
        if (res.status != 200 || request != this.lastRequest) return;
        this.products = res.data.result;
        this.admin = res.data.admin;
        this.products.forEach(normalizePhone);
        this.showClientHistory = true;
      });
    },
  },
};
</script>
